import { useEffect, useState } from 'react';

import { fetchData } from './vacationRentalWidgetDataFetcher';
import { trackFHHWidgetClick, trackFHHWidgetImpression } from '../widgetTracking';

import './vacation-rental-wigdet.css';
// @ts-ignore cannot find types for an image
import cabinImg from '../icons/cabin.png';

interface Props {
    destination?: string;
    latSw: number;
    lngSw: number;
    latNe: number;
    lngNe: number;
    bookingFrom?: string;
    bookingTo?: string;
    initialResults?: number;
}

export const VacationRentalWidget = ({ destination, latSw, lngSw, latNe, lngNe, bookingFrom, bookingTo, initialResults = 0 }: Props) => {
    const [numResults, setNumResults] = useState(initialResults);

    const trackImpression = () => trackFHHWidgetImpression(bookingFrom, bookingTo, destination);
    const trackClick = () => trackFHHWidgetClick(bookingFrom, bookingTo, destination);
    const dateQueryParams = bookingFrom && bookingTo ? `&booking_from=${bookingFrom}&booking_to=${bookingTo}` : '';
    const queryParams = `?lat_sw=${latSw}&lng_sw=${lngSw}&lat_ne=${latNe}&lng_ne=${lngNe}${dateQueryParams}`;

    useEffect(() => {
        fetchData(latSw, lngSw, latNe, lngNe).then((response) => {
            if (response.data?.stats) {
                setNumResults(response.data.stats.numResults);
                trackImpression();
            }
        });
    }, [latSw, lngSw, latNe, lngNe]);

    if (numResults <= 0) {
        return null;
    }

    return (
        <div className="vacation-rental-widget">
            <img src={cabinImg.src} className="vacation-rental-widget-image" alt="Bilde av hytte" />
            <div className="vacation-rental-widget-details">
                <div className="vacation-rental-widget-text">
                    <h4 data-testid="vacation-rental-widget-title">
                        {destination ? `Finn feriehjem og hytter i ${destination}` : 'Finn feriehjem og hytter i området'}
                    </h4>
                    <p className="u-d1 u-mb0">Søk blant {numResults} unike overnattingssteder</p>
                </div>
                <a
                    className="button button--small vacation-rental-widget-button"
                    onClick={trackClick}
                    href={`/reise/feriehus-hytteutleie/resultat/${queryParams}`}
                    target="_blank"
                    rel="noreferrer">
                    <i className="icon icon--search-blue" />
                    Søk feriehjem
                </a>
            </div>
        </div>
    );
};
